export default __webpack_public_path__ + "static/media/logo05.24111771.svg";